/** Ошибка API в формате бэкенда `{"error": {"code", "message", "details"}}`. */
export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  readonly details: Record<string, unknown>;

  constructor(status: number, code: string, message: string, details: Record<string, unknown> = {}) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.details = details;
  }
}

interface ErrorBody {
  error?: { code?: unknown; message?: unknown; details?: unknown };
}

/** Собрать ApiError из тела ответа (уже разобранного JSON) или из статуса. */
export function toApiError(status: number, body: unknown): ApiError {
  const err = (body as ErrorBody | null)?.error;
  const code = typeof err?.code === 'string' ? err.code : status === 0 ? 'network_error' : `http_${status}`;
  const message = typeof err?.message === 'string' ? err.message : code;
  const details =
    err?.details && typeof err.details === 'object' ? (err.details as Record<string, unknown>) : {};
  return new ApiError(status, code, message, details);
}

export function isApiError(e: unknown, code?: string): e is ApiError {
  return e instanceof ApiError && (code === undefined || e.code === code);
}
